/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {
    AsyncExportConfigCreateComponent,
    AsyncExportConfigEditComponent,
    AsyncExportConfigListComponent,
} from '../components/AsyncComponent/AsyncComponent';
import {useTranslation} from 'react-i18next';
import {config} from '../config';

const ExportConfig: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('configs.export_config.name')}`}</title>
                <meta name="description" content="Export Config"/>
            </Helmet>
            <Switch>
                <Route
                    exact
                    path={`${match?.url}`}
                    component={AsyncExportConfigListComponent}
                />
                <Route
                    exact
                    path={`${match?.url}/:id([0-9]+)`}
                    component={AsyncExportConfigEditComponent}
                />
                <Route
                    exact
                    path={`${match?.url}/create`}
                    component={AsyncExportConfigCreateComponent}
                />
                <Redirect
                    exact
                    from={`${match?.url}/`}
                    to={`${match?.url}`}
                />
            </Switch>
        </div>
    );
};

export default ExportConfig;
